import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import store from 'store';
import withInit from 'WithInit';
import * as AnimationActions from 'Animation/AnimationActions';
import CustomPropTypes from 'CustomPropTypes';
import * as StaticBuilderActions from 'StaticBuilder/StaticBuilderActions';
import * as StaticBuilderModalActions from 'StaticBuilderModals/actions';
import NavSideBarListWithSections from './NavSideBarListWithSections';

class NavSideBarList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onLoadStaticBuilderSection = this.onLoadStaticBuilderSection.bind(this);
  }

  onLoadStaticBuilderSection(step) {
    const self = this;
    const successAction = () => {
      window.scrollTo(0, 0);
      self.props.loadStaticBuilderSection(step);
    };

    window.SessionManager.save(successAction);
  }

  render() {
    const categories = {};
    const self = this;
    Object.keys(this.props.fieldOutline || {}).forEach((categoryKey) => {
      categories[categoryKey] = Object.keys(self.props.fieldOutline[categoryKey]);
    });


    return (
      <NavSideBarListWithSections
        {...this.props}
        categories={categories}
        onStep={this.props.onStep}
        loadStaticBuilderSection={this.onLoadStaticBuilderSection}
      />
    );
  }
}

NavSideBarList.defaultProps = {
  fieldData: {},
  fieldOutline: null,
  onStep: 0,
  releaseType: '',
};

NavSideBarList.propTypes = {
  fieldOutline: CustomPropTypes.hashmapOf(
    CustomPropTypes.hashmapOf(
      PropTypes.shape({
        header: PropTypes.string,
        fields: PropTypes.arrayOf(PropTypes.shape({
          id: PropTypes.string,
          label: PropTypes.string,
          options: PropTypes.oneOfType([
            PropTypes.arrayOf(
              PropTypes.shape({
                text: PropTypes.string,
                value: PropTypes.string,
              }),
            ),
            PropTypes.string,
          ]),
          type: PropTypes.string,
        })),
      }),
    ),
  ),
  onStep: PropTypes.number,
  releaseType: PropTypes.string,
};

const mapStateToProps = ({ StaticBuilderReducer }) => ({
  releaseType: StaticBuilderReducer.fieldData.release_type,
  fieldOutline: StaticBuilderReducer.fieldOutline,
  onStep: StaticBuilderReducer.step,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    loadStaticBuilderSection: StaticBuilderActions.loadStaticBuilderSection,
  }, dispatch)
);

export const NavSideBarListWithSectionsWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavSideBarList);

if (window.FormSwift && window.FormSwift.React) {
  const addedActions = Object.assign(
    {},
    {
      ...AnimationActions,
      ...StaticBuilderActions,
      ...StaticBuilderModalActions,
    },
    window.FormSwift.React.actions,
  );
  window.FormSwift.React.actions = addedActions;
} else {
  window.FormSwift = {
    React: {
      store,
      actions: {
        ...AnimationActions,
        ...StaticBuilderActions,
        ...StaticBuilderModalActions,
      },
    },
  };
}

export default withInit(NavSideBarListWithSectionsWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/NavSideBarList/index.jsx